import { useNavigate } from 'react-router-dom-v6'

import { ServiceAccountForm } from '../components/ServiceAccountForm'
import { useRegisterServiceAccount } from '../hooks'
import type { ServiceAccountInput } from '../types'

export function RegisterServiceAccount() {
  const navigate = useNavigate()
  const { mutateAsync: register } = useRegisterServiceAccount()

  const onSubmit = async (input: ServiceAccountInput) => {
    // Land on the new account's edit screen rather than the list — that's
    // where the generated clientEmail (and the Access tab) become visible.
    const account = await register(input)
    // Replace, not push: the registration form is spent once submitted (its
    // fields don't reflect the created account), so back should skip over it
    // rather than land the admin back on a stale create form.
    navigate(`/service-accounts/${account.id}/edit`, { replace: true })
  }

  return <ServiceAccountForm mode="create" onSubmit={onSubmit} />
}
